module.exports = __webpack_public_path__ + "static/img/xy_41000029.db1e681b.png";